import { render, staticRenderFns } from "./selectorder.vue?vue&type=template&id=ba7b2f78"
import script from "./selectorder.vue?vue&type=script&lang=js"
export * from "./selectorder.vue?vue&type=script&lang=js"
import style0 from "./selectorder.vue?vue&type=style&index=0&id=ba7b2f78&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports